import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Card,
  CardHeader,
  CardBody,
  Icon,
  Button,
  Divider
} from '@chakra-ui/react';
import { FaFlask, FaClipboardList, FaUpload, FaDollarSign, FaDoorOpen, FaPlay } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';

const QuickStart = ({ labName = 'Your Laboratory' }) => {
  const navigate = useNavigate();

  return (
    <Box minH="100vh" bg="gray.50" py={8}>
      <Container maxW="container.lg">
        <VStack align="stretch" spacing={6}>
          <HStack justify="space-between">
            <HStack>
              <Icon as={FaPlay} color="blue.500" boxSize={6} />
              <Heading size="lg">{labName} Portal – Quick Start</Heading>
            </HStack>
            <Button onClick={() => navigate('/lab-portal/dashboard')} variant="outline">Back to Dashboard</Button>
          </HStack>
          <Text color="gray.600">A one-page guide to the most important actions. Click a section to jump right in.</Text>

          {/* 1) Test Directory (first step) */}
          <Card>
            <CardHeader>
              <HStack>
                <Icon as={FaClipboardList} color="purple.500" />
                <Heading size="md">1) Upload Your Test Directory & Set Cash Prices</Heading>
              </HStack>
            </CardHeader>
            <CardBody>
              <HStack align="start" justify="space-between" spacing={6} w="full">
                <VStack align="start" spacing={2} flex="1">
                  <Text>• Upload your test menu (PDF, Excel, CSV, Word, images).</Text>
                  <Text>• Our team reviews and formats it for public visibility.</Text>
                  <Text>• After your menu is uploaded, you can optionally set cash prices in Test Costs.</Text>
                </VStack>
                <Button as={Link} to="/lab-portal/dashboard#test-directory" size="lg" colorScheme="blue">
                  Go to Upload
                </Button>
              </HStack>
            </CardBody>
          </Card>

          {/* 2) Submissions (second step) */}
          <Card>
            <CardHeader>
              <HStack>
                <Icon as={FaFlask} color="blue.500" />
                <Heading size="md">2) Manage Submissions</Heading>
              </HStack>
            </CardHeader>
            <CardBody>
              <VStack align="start" spacing={2}>
                <Text>• View inbound samples; mark as received and process results.</Text>
                <Text>• Review completed results and download documents.</Text>
                <Button size="sm" onClick={() => navigate('/lab-portal/dashboard')}>Open Submissions</Button>
              </VStack>
            </CardBody>
          </Card>

          <Divider />

          <HStack justify="space-between">
            <Text color="gray.600">Need help? Use the Show Tour button on the dashboard anytime.</Text>
            <Button leftIcon={<FaDoorOpen />} onClick={() => navigate('/lab-portal/dashboard')}>
              Back to Dashboard
            </Button>
          </HStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default QuickStart;


